import hotmartLogo from '@/assets/integrations/hotmart-logo.png';
import stripeLogo from '@/assets/integrations/stripe-logo.png';
import mercadopagoLogo from '@/assets/integrations/mercadopago-logo.png';
import kiwifyLogo from '@/assets/integrations/kiwify-logo.png';
import eduzzLogo from '@/assets/integrations/eduzz-logo.png';
import paypalLogo from '@/assets/integrations/paypal-logo.png';
import pagseguroLogo from '@/assets/integrations/pagseguro-logo.png';
import iuguLogo from '@/assets/integrations/iugu-logo.png';
import vindiLogo from '@/assets/integrations/vindi-logo.png';
import pagarmeLogo from '@/assets/integrations/pagarme-logo.png';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

const integrations = [
  { name: 'Hotmart', logo: hotmartLogo },
  { name: 'Stripe', logo: stripeLogo },
  { name: 'Mercado Pago', logo: mercadopagoLogo },
  { name: 'Kiwify', logo: kiwifyLogo },
  { name: 'Eduzz', logo: eduzzLogo },
  { name: 'PayPal', logo: paypalLogo },
  { name: 'PagSeguro', logo: pagseguroLogo },
  { name: 'Iugu', logo: iuguLogo },
  { name: 'Vindi', logo: vindiLogo },
  { name: 'Pagar.me', logo: pagarmeLogo },
];

export function IntegrationsSection() {
  return (
    <section className="py-20 md:py-32 bg-muted/50">
      <div className="container mx-auto px-4">
        <div className="mx-auto max-w-2xl text-center space-y-4 mb-16">
          <h2 className="text-3xl md:text-4xl font-bold">
            Conecte com seus gateways favoritos
          </h2>
          <p className="text-xl text-muted-foreground">
            Integração nativa com as principais plataformas de pagamento
          </p>
        </div>

        <TooltipProvider>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 max-w-5xl mx-auto">
            {integrations.map((integration) => (
              <Tooltip key={integration.name}>
                <TooltipTrigger asChild>
                  <div
                    className="flex items-center justify-center p-4 bg-card rounded-lg border hover:border-primary/50 transition-all cursor-pointer"
                  >
                    <img
                      src={integration.logo}
                      alt={integration.name}
                      className="h-16 w-auto object-contain grayscale hover:grayscale-0 transition-all"
                    />
                  </div>
                </TooltipTrigger>
                <TooltipContent>
                  <p>{integration.name}</p>
                </TooltipContent>
              </Tooltip>
            ))}
          </div>
        </TooltipProvider>
      </div>
    </section>
  );
}
